import Component from '../shared/component'

export const Request = Component('v-request', {
  model: {
    event: 'change'
  },
  props: {
    url: {
      type: String,
      default: null,
      required: true
    },
    preload: {
      default: null
    },
    params: {
      type: Object,
      default () {
        return {}
      }
    },
    headers: {
      type: Object,
      default () {
        return {}
      }
    },
    accept: {
      type: String,
      default: null
    },
    mode: {
      type: String,
      default: 'cors',
      valid: [
        'cors',
        'no-cors',
        'same-origin'
      ]
    },
    credentials: {
      type: String,
      default: 'same-origin',
      valid: [
        'omit',
        'include',
        'same-origin'
      ]
    },
    cache: {
      type: String,
      default: 'default',
      valid: [
        'default',
        'no-store',
        'reload',
        'no-cache',
        'force-cache',
        'only-if-cached'
      ]
    },
    redirect: {
      type: String,
      default: 'follow',
      valid: [
        'follow',
        'error',
        'manual'
      ]
    }
  },
  data () {
    return {
      preloaded: false,
      response: {
        loading: true,
        ok: null,
        status: null,
        json: null,
        text: null
      },
      signal: null
    }
  },
  computed: {
    search () {
      const query = new URLSearchParams()

      Object.keys(this.params).forEach(key => {
        const value = this.params[key]

        if (value !== undefined) {
          query.set(key, this.params[key])
        }
      })

      const search = query.toString()

      return search === '' ? '' : `?${search}`
    },

    location () {
      return this.url + this.search
    }
  },
  watch: {
    location: {
      immediate: true,
      handler () {
        if (this.preload !== null && !this.preloaded) {
          let text = null
          let json = null
          try {
            json = JSON.parse(this.preload)
            text = this.preload
          } catch (err) {
            text = JSON.stringify(this.preload)
            json = this.preload
          }

          this.preloaded = true
          this.response = {
            loading: false,
            ok: true,
            status: 200,
            text,
            json
          }
        } else {
          this.fetch()
        }
      }
    },

    response: {
      immediate: true,
      deep: true,
      handler () {
        this.$emit('change', { ...this.response })
      }
    }
  },
  methods: {
    fetch () {
      if (this.signal) {
        this.signal.abort()
      }

      this.signal = this.$http.signal()

      const {
        headers,
        accept,
        mode,
        credentials,
        cache,
        redirect,
        signal
      } = this

      this.response.loading = true

      this.$http.get(this.url + this.search, {
        headers: { ...headers,
          accept: accept === null ? headers.accept : accept
        },
        mode,
        credentials,
        cache,
        redirect,
        signal
      })
        .then(response => Promise.all([
          response.ok,
          response.status,
          response.text()
        ]))
        .then(([ok, status, text]) => {
          let json = null
          try {
            json = JSON.parse(text)
          } catch (err) {}

          this.response = {
            loading: false,
            ok,
            status,
            text,
            json
          }
        })
        .catch(() => {
          if (!signal.aborted) {
            this.response = {
              loading: false,
              ok: false,
              status: 500,
              text: null,
              json: null
            }
          }
        })
    }
  },
  render (createElement) {
    if (this.$scopedSlots.default) {
      return createElement(
        'div',
        {
          class: 'request'
        },
        this.$scopedSlots.default({ ...this.response })
      )
    }
  }
})
